export default __webpack_public_path__ + "static/media/astuce.3160f472.svg";